// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H18V8H2V2ZM2 10H18V22H2V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22H20V2H22Z"}}]};

const VerticalFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'vertical-filled',
    ref,
    icon: element,
  },
));

VerticalFilledIcon.displayName = 'VerticalFilledIcon';

export default VerticalFilledIcon;
